import * as React from "react";
import Appbar from "../../../../components/appBar/appBar";
import Footer from "../../../../components/footer/footer";
import ComplianceMonitor from "./complianceGroup/groupEntity";
export default function CompliancePage(props) {
  return (
    <div>
      <Appbar />
      <div style={{ marginTop: "80px", marginBottom: "60px" }}>
        <ComplianceMonitor />
      </div>
      <Footer />
    </div>
  );
}
